// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Ag1B5","head":"styles_head__BxUlP","body":"styles_body__dhafM"};